import { DeviceSession } from "./DeviceSession";
import { UserAvailabilityStatus } from "./UserAvailabilityStatus";
import { UserMultiplayerSessionState } from "./UserMultiplayerSessionState";

export class SessionUser {
    userId!: string;
    state!: UserMultiplayerSessionState;
    userAvailabilityStatus!: UserAvailabilityStatus;
    deviceSessions?: DeviceSession[];
}